<template>
  <v-container
    fluid
    class="mt-2"
    :class="
      $vuetify.breakpoint.mdAndUp
        ? 'py-5 px-10'
        : '' && $vuetify.breakpoint.smAndUp
        ? 'py-2 px-2'
        : ''
    "
  >
    <pageHeader title="Privacy Policy" />

    <p v-html="html" />
  </v-container>
</template>

<script>
import pageHeader from '@/components/layout/PageHeader'
export default {
  name: 'Policy',
  components: {
    pageHeader
  },
  metaInfo: {
    title: 'Policy',
    titleTemplate: '%s | LinkBook.io',
    meta: [
      {
        name: 'description',
        content:
          'By using our website, you hereby consent to our Privacy Policy and agree to its terms'
      }
    ]
  },
  data() {
    return {
      companyName: 'LinkBook.io',
      linkparams: null,
      editmodal: false,
      html: `<div class="card-body">
      <p>Last updated: 2025-04-08</p>

      <h3>1. Introduction</h3>
      <p>Welcome to LinkBook.io.</p>
      <p>LinkBook.io ("us", "we", or "our") operates ${process.env.VUE_APP_HOST} (hereinafter referred to as "Service").</p>
      <p>Our Privacy Policy governs your visit to ${process.env.VUE_APP_HOST}, and explains how we collect, safeguard and disclose information that results from your use of our Service.</p>
      <p>We use your data to provide and improve Service. By using Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.</p>

      <h3>2. Definitions</h3>
      <p>SERVICE means the ${process.env.VUE_APP_HOST} website operated by LinkBook.io.</p>
      <p>PERSONAL DATA means data about a living individual who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).</p>
      <p>USAGE DATA is data collected automatically either generated by the use of Service or from Service infrastructure itself (for example, the duration of a page visit).</p>
      <p>COOKIES are small files stored on your device (computer or mobile device).</p>

      <h3>3. Information Collection and Use</h3>
      <p>We collect several different types of information for various purposes to provide and improve our Service to you.</p>

      <h3>4. Types of Data Collected</h3>
      <h3>Personal Data</h3>
      <p>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:</p>
      <ul>
        <li>Email address</li>
        <li>First name and last name</li>
        <li>Importing browser bookmarks</li>
        <li>Usage Data Analytics</li>
      </ul>

      <h3>Tracking & Cookies Data</h3>
      <p>We use cookies and similar tracking technologies to track the activity on our Service and hold certain information. We use the following tracking services:</p>
      <ul>
        <li>Google Analytics</li>
        <li>Google Ad Words</li>
        <li>Facebook Pixel</li>
      </ul>

      <h3>5. Use of Data</h3>
      <p>LinkBook.io uses the collected data for various purposes:</p>
      <ul>
        <li>To provide and maintain our Service</li>
        <li>To notify you about changes to our Service</li>
        <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
        <li>To provide customer support</li>
        <li>To gather analysis or valuable information so that we can improve our Service</li>
        <li>To monitor the usage of our Service</li>
        <li>To detect, prevent and address technical issues</li>
      </ul>

      <h3>6. Data Protection Rights Under GDPR</h3>
      <p>If you are a resident of the European Union (EU) and European Economic Area (EEA), you have certain data protection rights. You have the right to:</p>
      <ul>
        <li>Access your Personal Data</li>
        <li>Rectify your Personal Data</li>
        <li>Erase your Personal Data</li>
        <li>Restrict processing of your Personal Data</li>
        <li>Object to processing of your Personal Data</li>
        <li>Data portability</li>
        <li>Withdraw consent</li>
      </ul>

      <h3>7. California Privacy Rights (CCPA)</h3>
      <p>If you are a California resident, you have specific rights regarding your personal information:</p>
      <ul>
        <li>Right to know what personal information is collected</li>
        <li>Right to know whether personal information is sold or disclosed</li>
        <li>Right to say no to the sale of personal information</li>
        <li>Right to access your personal information</li>
        <li>Right to equal service and price</li>
      </ul>

      <h3>8. Children's Privacy</h3>
      <p>
        Our Services are not intended for use by children under the age of 13 (“Child” or “Children”). We do not knowingly collect personally identifiable information from Children under 13. If you become aware that a Child has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from Children without verification of parental consent, we take steps to remove that information from our servers.
      </p>

      <h3>9. Changes to This Privacy Policy</h3>
      <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date at the top of this Privacy Policy.</p>

      <h3>10. Contact Us</h3>
      <p>If you have any questions about this Privacy Policy, please contact us:</p>
      <ul>
        <li>By email: info@linkbook.io</li>
      </ul>
      </div>`
    }
  }
}
</script>
